import type { EthereumAddress, } from "@bracket/sharedTypes";

/** the block chain address for an etheruem smart contract */
export declare type ContractAddress = EthereumAddress & { };

/** check if a string is a valid contract address - 42 characters, starts with 0x, and is hex */
export const isContractAddress = (value: unknown): value is ContractAddress =>
  typeof value === "string" && value.length === 42 && /^0x[0-9a-fA-F]+$/.test(value);

/** Right now a contract address but may be extended for other unique ways to identify a contract. */
export declare type ContractIdentifier = ContractAddress;

/** check if a string is a valid contract identifier */
export const isContractIdentifier = (value: unknown): value is ContractIdentifier => {
  return isContractAddress(value);
}

